import { call, put, takeLatest } from "redux-saga/effects";

import { IInvoice } from "interfaces/entities/invoice";
import { ApiManager } from "services/api";
import { deserializeCollection } from "services/api/invoice/invoice-serializer";
import { IActionWithPayload } from "store/helper";
import { InvoicesViewActions, InvoicesViewActionsNames } from "store/views/invoices/actions";

import { CRUDAction, RequestAction } from "../actions";

import { INVOICE, InvoiceActions } from "./actions";
import { IFetchInvoicesCollectionPayload } from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchCollection(
  action: IActionWithPayload<InvoicesViewActionsNames, IFetchInvoicesCollectionPayload>
) {
  const params = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const invoicesResponse = yield call(ApiManager.invoiceApi.fetchAll, params);

  if (invoicesResponse.result) {
    const invoicesData: IInvoice[] = deserializeCollection(invoicesResponse.result);
    yield put(InvoicesViewActions.setInvoicesData({ data: invoicesData }));
    yield put(InvoiceActions.fetchCollectionSuccess({ values: invoicesData }));
  } else {
    yield put(InvoiceActions.fetchCollectionFailure({ error: invoicesResponse.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* invoiceSagas() {
  yield takeLatest(INVOICE[CRUDAction.FETCH_COLLECTION][RequestAction.REQUEST], fetchCollection);
}
